import React, { useRef, useState } from "react";
import {
  AiFillBell,
  AiFillDashboard,
  AiFillDatabase,
  AiOutlineMenu,
  AiOutlineOrderedList,
  AiOutlineUser,
} from "react-icons/ai";
import {
  MdHomeRepairService,
  MdPostAdd,
  MdBookOnline,
  MdDarkMode,
} from "react-icons/md";
import { RxCross1 } from "react-icons/rx";

import { NavLink } from "react-router-dom";

function Header(props) {
  const [isOpen, setIsOpen] = useState(false);
  const dashboardSideMenu = useRef();
  const adminData = localStorage.getItem("adminDetails");
  const data = JSON.parse(adminData);

  function toggleProfileMenu() {
    setIsOpen(!isOpen);
  }

  function logout() {
    window.location.reload();
    localStorage.removeItem("adminDetails");
  }

  return (
    <div>
      {/* left responsive side bar dashboard menu */}
      <div className="font-primary">
        <div
          ref={dashboardSideMenu}
          className="dark:bg-dark dark:text-white hidden p-10 text-white font-primary bg-primary h-full absolute bottom-0"
        >
          <div className="flex justify-between items-center mb-6 pr-2 pt-4 pb-4 bg-transparent text-white font-semibold">
            <img src="../images/digitalmechanic.png" width="70" alt="logo" />
            <div>
              <h2 className="text-xl ">Admin</h2>
              <span className="text-sm">Dashboard</span>
            </div>
            <button
              className="text-white pl-10"
              onClick={() => (dashboardSideMenu.current.style.display = "none")}
            >
              <RxCross1 size="20" />
            </button>
          </div>
          <ul>
            <NavLink
              to="/admin/dashboard"
              className="admin-nav admin-dashboard"
            >
              <span>
                <AiFillDashboard />
              </span>
              <span className="pl-2">Dashboard</span>
            </NavLink>
            <NavLink to="/admin/products" className="admin-nav admin-dashboard">
              <span>
                <AiFillDatabase />
              </span>
              <span className="pl-2">Products</span>
            </NavLink>
            <NavLink to="/admin/posts" className="admin-nav admin-dashboard">
              <span>
                <MdPostAdd />
              </span>
              <span className="pl-2">Posts</span>
            </NavLink>
            <NavLink to="/admin/orders" className="admin-nav admin-dashboard">
              <span>
                <AiOutlineOrderedList />
              </span>
              <span className="pl-2">Orders</span>
            </NavLink>
            <NavLink to="/admin/users" className="admin-nav admin-dashboard">
              <span>
                <AiOutlineUser />
              </span>
              <span className="pl-2">Users</span>
            </NavLink>
            <NavLink to="/admin/services" className="admin-nav admin-dashboard">
              <span>
                <MdHomeRepairService />
              </span>
              <span className="pl-2">Services</span>
            </NavLink>
            <NavLink to="/admin/bookings" className="admin-nav admin-dashboard">
              <span>
                <MdBookOnline />
              </span>
              <span className="pl-2">Bookings</span>
            </NavLink>
          </ul>
        </div>
      </div>
      {/* head section with profile dark mode and bell icon */}
      <div className="flex justify-between items-center bg-gray-100 p-3 w-[88%] mx-auto dark:bg-dark dark:text-white">
        <div className="admin-dashboard mt-5 mb-5">
          <button
            onClick={() => (dashboardSideMenu.current.style.display = "block")}
            className="flex justify-center items-center text-gray-500 dark:text-white"
          >
            <span className="p-2">
              <AiOutlineMenu size="25" />
            </span>
          </button>
          <img src="../images/digitalmechanic.png" alt="logo" width="60" />
          <span className="dark:text-white text-md font-semibold text-primary">
            Admin
            <br />
            Dashboard
          </span>
        </div>
        <div className="flex text-gray-500 w-36 justify-between items-center dark:text-white">
          <div onClick={props.enableDarkMode} className="cursor-pointer">
            <MdDarkMode size="25" />
          </div>
          <div>
            <AiFillBell size="25" />
          </div>
          <img
            onClick={toggleProfileMenu}
            className="rounded-full cursor-pointer"
            width="50"
            src="../images/profile.png"
            alt="logo"
          />
        </div>
      </div>
      {/* Dropdown menu */}
      {isOpen && (
        <div className="dark:bg-slate-600 origin-top-right absolute md:right-24 right-7 mt-[-30px] w-46 rounded-md shadow-lg bg-white focus:outline-none">
          <div className="py-1">
            <NavLink className="dark:text-white block px-4 py-2 text-sm text-gray-700 dark:hover:text-black hover:bg-gray-100 hover:text-gray-900">
              {data && data.email.split("").slice(0, 6)}
            </NavLink>
            <NavLink className="dark:text-white block px-4 py-2 text-sm text-gray-700 dark:hover:text-black hover:bg-gray-100 hover:text-gray-900">
              {data && data.email}
            </NavLink>
            <NavLink
              onClick={logout}
              className="dark:text-white block px-4 py-2 text-sm text-gray-700 dark:hover:text-black hover:bg-gray-100 hover:text-gray-900"
            >
              Logout
            </NavLink>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
